export default __webpack_public_path__ + "static/char-s-16-cht-17cad19773707e5afc63efc59c0f4bb2.png";